import { createFeatureSelector, createSelector } from '@ngrx/store';
import { appInitializationFeatureKey } from '../reducers';
import { AppInitializationState } from '../reducers/app-initialization.reducer';

export const selectAppInitialization =
  createFeatureSelector<AppInitializationState>(appInitializationFeatureKey);

export const selectAppInitialized = createSelector(
  selectAppInitialization,
  (state) => state.initialized
);
